var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115756_200549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6665 27.2857C36.6665 29.1791 35.1314 30.7143 33.2379 30.7143H4.09508C2.20165 30.7143 0.666504 29.1791 0.666504 27.2857V8.42857C0.666504 6.53514 2.20165 5 4.09508 5H33.2379C35.1314 5 36.6665 6.53514 36.6665 8.42857V27.2857Z",
    fill: "#263B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0562 14.0007L10.0867 19.8748C10.0867 19.8748 9.58648 17.39 9.53698 17.078C8.41573 14.5198 6.76123 14.6622 6.76123 14.6622L8.71123 22.2507V22.2492H11.082L14.3602 14.0007H12.0562ZM13.9335 22.2507H16.0867L17.3887 14.0007H15.2085L13.9335 22.2507ZM29.1727 14.0007H26.907L23.3745 22.2507H25.5135L25.9545 21.0725H28.6515L28.881 22.2507H30.8407L29.1727 14.0007ZM26.5515 19.4967L27.7237 16.379L28.3372 19.4967H26.5515ZM20.4435 16.4052C20.4435 15.9507 20.817 15.6125 21.888 15.6125C22.584 15.6125 23.3812 16.118 23.3812 16.118L23.7307 14.3862C23.7307 14.3862 22.7122 14 21.7125 14C19.4482 14 18.2805 15.083 18.2805 16.454C18.2805 18.9335 21.2647 18.5938 21.2647 19.8672C21.2647 20.0855 21.0915 20.5902 19.8487 20.5902C18.6022 20.5902 17.7795 20.1335 17.7795 20.1335L17.4082 21.7955C17.4082 21.7955 18.2055 22.25 19.746 22.25C21.2902 22.25 23.4322 21.095 23.4322 19.436C23.4322 17.4402 20.4435 17.2962 20.4435 16.4052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82556 18.3328L9.10106 14.7718C9.10106 14.7718 8.77331 14 7.92131 14C7.06931 14 4.59131 14 4.59131 14C4.59131 14 8.83706 15.254 9.82556 18.3328Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115756_200549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.51c5a7f5f609ddcb05e27bcaa63e4c82.svg";
export { ForwardRef as ReactComponent };